import type { BaseLoggerInterface } from './base';
// @ts-expect-error - Ignore the fact that we're importing a file that doesn't exist
import loggerClient from './logger-browser?client';
// @ts-expect-error - Ignore the fact that we're importing a file that doesn't exist
import loggerServer from './logger-svelte-kit-ssr?server';

// Export the server logger if we're on the server, otherwise export the client logger
export default (import.meta.env.SSR
	? loggerServer
	: loggerClient) as BaseLoggerInterface;
